import {
  SET_LOGIN_VALUE,
  LOGIN_LOADING,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOGOUT,
} from '../actions/loginActions';

const initialState = {
  loading: false,
  isAuthenticated: false,
  email: 'admin@uniedu.py',
  login: {
    email: 'admin@uniedu.py',
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOGIN_VALUE:
      return { ...state, ...action.payload };
    case LOGIN_LOADING:
      return { ...state, loading: true };
    case LOGIN_SUCCESS:
      return { ...state, ...action.payload, loading: false };
    case LOGIN_FAILED:
      return { ...initialState };
    case LOGOUT:
      return { ...initialState };
    default:
      return state;
  }
}

export const getLoginData = state => state.login;
export const getLoginStatus = state => state.login.loading;
export const getLoginError = state => state.login.error;
